// Лучшая грань кости урона — критический успех (такую кость не перебрасывают).
// Раньше лучшей была +1; теперь ее место заняла вторая грань 0 (см.
// DAMAGE_DICE_FACES), и критический успех — любая из двух граней 0
export const DAMAGE_DICE_MAX_VALUE = 0;
// Худшая грань кости урона: ниже нее грань не опускается и со штрафом форы
// новичкам (см. applyDamageDiceFacePenalty)
export const DAMAGE_DICE_MIN_VALUE = -3;

// Грани кости урона: базовый d6 -> значение урона. Раньше маппинг был линейным
// (бросок - 5, грани -4..+1); затем грань -4 заменена второй -1 (среднее -1
// вместо -1.5), а теперь и грань +1 заменена вторым 0: грани -3, -2, -1, -1,
// 0, 0, среднее -7/6 (около -1.17) при той же равновероятности граней d6.
// В записях старых партий кости хранятся готовыми значениями (+1 там
// встречается) — показ таких значений см. getDamageDiceFaceLayout.
// Порядок сохраняет монотонность: больший бросок d6 не хуже меньшего, поэтому
// подкрутки ботов (пол minRoll, см. getBotD6MinRoll, и прибавка rollBonus, см.
// getBotD6RollBonus) только улучшают грань
export const DAMAGE_DICE_FACES = {
  1: -3,
  2: -2,
  3: -1,
  4: -1,
  5: 0,
  6: 0,
};

// Сколько костей урона идет в формулу урона ближнего боя. Отряд, бросающий
// больше костей (селестиалы, CELECTIALS_MELEE_DAMAGE_DICE_COUNT), учитывает
// лучшие из них (см. getMeleeCountedDiceRolls)
export const MELEE_COUNTED_DAMAGE_DICE_COUNT = 2;
